module.exports = __webpack_public_path__ + "static/media/greenpeace_magazin.8a4f3c7a.jpg";